// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"TL-z","carouselContainer":"UL-z"};